import loadable from '@loadable/component';

const applyConfig = (config) => {
  config.settings = {
    ...config.settings,
    // matomoSiteId: 'xxxxxxxxx',
    // matomoUrlBase: 'https://ingestion.webanalytics.italia.it/',
    // italiaThemeViewsConfig: {
    //   ...config.settings.italiaThemeViewsConfig,
    //   imagePosition: 'afterHeader', // possible values: afterHeader, documentBody
    // },
    siteProperties: {
      /*
        Per tutte le props di siteProperties, può essere definito un oggetto per i siti multilingua, strutturato in questo modo:
        {'default': _valore_della_prop, 'it': _valore_della_prop,...}
        Se l'oggetto non è strutturato in questo modo, viene usato l'oggetto stesso, altrimenti viene preso il valore della corrispondente alla prop della lingua corrente o alla prop 'default' se esiste.
      */
      ...config.settings.siteProperties,
      siteTitle: 'Nuovo Circondario Imolese',
      siteSubtitle: '',
      parentSiteTitle: 'Regione Emilia-Romagna',
      parentSiteURL: 'https://www.regione.emilia-romagna.it/',
      subsiteParentSiteTitle: 'Nuovo Circondario Imolese',
      enableCustomerSatisfaction: false,
    },

    externalRoutes: [...config.settings.externalRoutes],

    defaultExcludedFromSearch: {
      portalTypes: ['Image'],
    },
    loadables: {
      ...config.settings.loadables,
      'subsite-cisst': loadable.lib(() => import('./subsites/cisst')),
      'subsite-ddt': loadable.lib(() => import('./subsites/ddt')),
      'subsite-polizia': loadable.lib(() => import('./subsites/polizia')),
      'subsite-psc': loadable.lib(() => import('./subsites/psc')),
      'subsite-ssa': loadable.lib(() => import('./subsites/ssa')),
      'subsite-tributi': loadable.lib(() => import('./subsites/tributi')),
      'subsite-laboratorio': loadable.lib(() =>
        import('./subsites/laboratorio'),
      ),
      'subsite-suap': loadable.lib(() => import('./subsites/suap')),
    },

    matomoSiteId: 'me0K4ZM3NA',
    matomoUrlBase: 'https://ingestion.webanalytics.italia.it/',

    'volto-gdpr-privacy': {
      ...config.settings['volto-gdpr-privacy'],
      defaultPanelConfig: {
        ...config.settings['volto-gdpr-privacy'].defaultPanelConfig,
        last_updated: '2023-06-14T12:43:00+00:00',

        technical: {
          ...config.settings['volto-gdpr-privacy'].defaultPanelConfig.technical,
          choices: [
            {
              config_key: 'MATOMO',
              text: {
                it: {
                  title: 'Matomo',
                  description:
                    "I cookie di Matomo sono usati per analizzare la navigazione sul sito al fine di migliorarla e fornire all'utente un'esperienza di navigazione migliore possibile.",
                },
                en: {
                  title: 'Matomo',
                  description:
                    'Matomo cookie are used to analyze navigation on the site in order to improve it and provide the user with the best possible browsing experience.',
                },
                fr: {
                  title: 'Matomo',
                  description:
                    "Les cookie de Matomo sont utilisés pour analyser la navigation sur le site afin de l'améliorer et offrir à l'utilisateur la meilleure expérience de navigation possible.",
                },
              },
            },
            ...config.settings[
              'volto-gdpr-privacy'
            ].defaultPanelConfig.technical.choices.filter(
              (f) => f.config_key !== 'GANALYTICS',
            ),
          ],
        },
      },
    },
  };

  config.blocks.blocksConfig.listing = {
    ...config.blocks.blocksConfig.listing,
    listing_bg_colors: [], //{name:'blue', label:'Blu'},{name:'light-blue', label:'Light blue'},{name:'sidebar-background', label:'Grey'}
    listing_items_colors: [], //{name:'blue', label:'Blu'},{name:'light-blue', label:'Light blue'},{name:'sidebar-background', label:'Grey'}
  };

  return config;
};

export default applyConfig;
